<template>
    <div class="all">
        <div class="container">
            <div class="grid h-auto">
                <div class="grid-header">
                    <h2 class="title">完善信息 <span class="fs12 fwl color-red">（请务必填写真实信息，否则可能会影响您的正常使用）</span></h2>
                </div>
                <div class="grid-body mt20">
                    <div class="form-warp form-home">
                        <div class="item">
                            <span class="name db al"><i class="color-red">*</i> 真实姓名:</span>
                            <input class="input-text" v-model="tryData.nickname" maxlength="30" type="text" placeholder="请输入您的姓名"/>
                        </div>
                        <div class="item">
                            <span class="name db al"><i class="color-red">*</i> 公司名称:</span>
                            <input class="input-text" v-model="tryData.companyName" maxlength="30" type="text" placeholder="请输入您的公司名称"/>
                        </div>
                        <div class="item">
                            <span class="name db al"><i class="color-red">*</i> 单位类型:</span>
                            <div>
                                <el-radio v-for="(item,index) in companyTypes" :key="index" v-model="tryData.companyType" :label="item">{{item}}</el-radio>
                            </div>
                        </div>
                        <div class="item">
                            <span class="name db al"><i class="color-red">*</i> 职位:</span>
                            <input class="input-text" v-model="tryData.job" maxlength="30" type="text" placeholder="请输入您的职位"/>
                        </div>
                        <div class="item">
                            <span class="name db al"><i class="color-red">*</i> 地区:</span>
                            <city levels="3" @cityCallback="saveCity"></city>
                        </div>
                        <div class="item">
                            <span class="name db al"><i class="color-red">*</i>需求描述:</span>
                            <textarea class="input-textarea" v-model="tryData.functionDesc" name="" rows="4" maxlength="150" placeholder="请输入您的需求描述"></textarea>
                        </div>
                        <div class="item ac">
                            <button class="btn save mt20 btn-jbblue" @click="saveTry();">保存信息</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import {mapState} from 'vuex';
import city from '../components/city.vue';
export default {
    components:{city},
    computed:{
        ...mapState({
            companyTypes: state => state.show.companyTypes
        })
    },
    data() {
        return {
            tryData:{
                nickname:'',
                companyName:'',
                job:'',
                regionName:'',
                functionDesc:'',
                companyType:'1'
            },//使用信息
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.$sensors.track('clickTrial', {
                page_source:'申请试用页面'
            });
        }) 
    },
    created() {
		
    },
    methods: {
        // 选择地区
        saveCity (name) {
            this.tryData.regionName = name;
        },
        isChinese(str) {
            var reg = /^[\u4E00-\u9FA5]+$/;
            if(reg.test(str)){
                return true;
            }else{
                return false;
            }
        },
        // 保存试用信息
        saveTry () {
            let that = this;
            let tryData = that.tryData;
            if(!this.isChinese(tryData.nickname)){
                that.$utils.alertText('姓名只能是汉字');
                return;
            }
            if(!this.isChinese(tryData.job)){
                that.$utils.alertText('职位只能是汉字');
                return;
            }
            if(tryData.nickname.length <1){
                that.$utils.alertText('姓名不能为1个字');
                return;
            }else if(tryData.companyName.length <3){
                that.$utils.alertText('公司名不能少于4个字');
                return;
            }else if(tryData.job == ''){
                that.$utils.alertText('职位不能为空');
                return;
            }else if(tryData.regionName == ''){
                that.$utils.alertText('地区不能为空');
                return;
            }else if(tryData.functionDesc.length <4){
                that.$utils.alertText('需求描述不能少于5个子');
                return;
            }
            
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('user/index/commit-trial-info',{data:tryData},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.$sensors.track('freeTrial', {
                        is_success:true,
                        customer_id:that.tryData.companyName,
                        fail_reason:'',
                        contact_phone:''
                    });
                    that.$parent.trialInfoType = 2;
                    sessionStorage.setItem('trialInfoType',2);//提交成功变为3
                    that.$utils.alertText('提交成功！');
                    that.$router.push({path:that.$parent.baseUrl+'/yuYingGather'});
                });         
            }) 
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/fillInTrial.vue